import { api } from '@/api';
import { DEFAULT_CURSOR_PAGE_LIMIT, type CursorPageParams } from '@/api/cursorPagination';
import type { DeviceAssignmentHistoryResponse } from '../types';

// fetchDeviceAssignmentHistory loads one page of the device's company assignment history,
// scoped to the caller's active company. A 403 means the company is unknown or not
// permitted; the backend does not distinguish the two.
export async function fetchDeviceAssignmentHistory(
  deviceId: string,
  companyId: string,
  { limit = DEFAULT_CURSOR_PAGE_LIMIT, cursor }: CursorPageParams = {}
): Promise<DeviceAssignmentHistoryResponse> {
  return api.get<DeviceAssignmentHistoryResponse>(`/v1/devices/${deviceId}/assignment-history`, {
    params: { companyId, limit, cursor },
  });
}
